import ScrollToTop from "react-scroll-to-top";
import Header from '../Layout/Header/Header';
import Sidebar from '../Layout/Sidebar/Sidebar';
import MailDetails from '../Email/MailDetails';

const Email = () => {
    return (
        <div className="layout-wrapper">
            <Header/>
            <Sidebar/>
            <MailDetails/>
            <ScrollToTop smooth color="#0019FF" />
        </div>
    )
}
export default Email;